import React, { useState, useEffect } from "react";
import LaunchpadComponent from "../Launchpad/LaunchpadComponent";
import {
  _InfinityFactoryContractGetAllDataByAddress,
  _IDOSaleTotalCollectedFunds,
} from "../../Services/Web3Connection";
import Pagination from "../Pagination";
import Loading from "../Animation/Loading/Loading";

function UpcomingTab() {
  const [FactoryContract, setFactoryContract] = useState(null);
  const [Upcomingdata, setUpcomingdata] = useState([]);
  const [totalContent, settotalContent] = useState(1);
  const [showPerPage, setshowPerPage] = useState(6);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage,
  });

  const onPaginationsChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  useEffect(async () => {
    let data = await _InfinityFactoryContractGetAllDataByAddress();
    setFactoryContract(data);
    data.map((data, key) => {
      isUpcoming(data);
    });
  }, []);

  const isUpcoming = async (fcData) => {
    let raisedAmount = await _IDOSaleTotalCollectedFunds(fcData[2][1]);
    if (
      !(raisedAmount / Math.pow(10, 18) >= fcData[1][2] / Math.pow(10, 18)) &&
      fcData[1][3] / Math.pow(10, 18) >
        parseInt(new Date().getTime() / 1000 || raisedAmount === "")
    ) {
      setUpcomingdata((data) => [...data, fcData]);
    }
  };

  const handleTimeout = () => {
    document.getElementById("loading").innerHTML = "Nothing to show yet";
  };

  console.log(Upcomingdata.length);
  return (
    <>
      <div style={{ display: "none" }}>{setTimeout(handleTimeout, 5000)}</div>
      {Upcomingdata.length == 0 ? (
        <>
          <div
            style={{
              color: "#ff832e",
              textAlign: "center",
              position: "relative",
            }}
          >
            <h3
              id="loading"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Loading />
            </h3>
          </div>
        </>
      ) : (
        <>
          <div className="container cardlist">
            {Upcomingdata.slice(pagination.start, pagination.end)
              .map((data, key) => <LaunchpadComponent key={key} data={data} />)
              .reverse()}
          </div>
          <Pagination
            showPerPage={showPerPage}
            onPaginationsChange={onPaginationsChange}
            totalContent={Upcomingdata.length}
          />
        </>
      )}
    </>
  );
}

export default UpcomingTab;
